import React from 'react';

const LogoLight: React.FC = () => {
    return (
        <svg
            viewBox='0 0 56 56'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g>
                <path
                    d='M44.13,14.42c0-3.4,.02-6.76,.02-9.29h0c7.17,5.08,11.85,13.44,11.85,22.88,0,15.46-12.53,27.99-28,27.99-5.62,0-11.1-1.68-15.74-4.84-3.38-2.3-6.21-5.31-8.31-8.81-2.51-4.2-3.95-9.11-3.95-14.35C0,16.89,6.48,7.29,15.86,2.75,19,1.25,22.4,.34,25.87,.08c.7-.05,1.41-.08,2.11-.08,3.65,0,7.12,.61,10.3,2.1,6.71,3.4,2.05,13.22-4.44,10.65-.05-.01-.09-.03-.13-.04-.04-.01-.08-.03-.13-.04-.4-.13-.88-.26-.88-.26-1.53-.49-3.15-.74-4.84-.74-7.59,0-13.96,5.21-15.73,12.24-.16,.64-.28,1.29-.36,1.95l-.02,.22c-.04,.28-.07,.57-.08,.85v.07c-.03,.29-.03,.59-.03,.89,0,8.96,7.27,16.22,16.23,16.22,2.23,0,4.44-.46,6.49-1.36h.02c.29-.13,.58-.27,.86-.41,5.01-2.57,8.51-7.64,8.83-13.58,.03-.08,.03-.17,.03-.26,0-.43,0-1.14,0-2.07,0-1.71,.01-4.13,.01-6.82,0-1.67,0-3.43,.01-5.19Zm-6.43,13.58c0,5.32-4.34,9.64-9.7,9.64s-9.7-4.31-9.7-9.64,4.34-9.64,9.7-9.64,9.7,4.31,9.7,9.64Z'
                    fill='#fff'
                    id='Logo'
                />
            </g>
        </svg>
    );
};

export default LogoLight;
